// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"68":"a3fe6143","165":"bd4bf1ec","391":"93bd7fa4","556":"0185e5fa","646":"fa8d889d","887":"d2c9c070"}[chunkId] + ".js";
};